import React from 'react';
import { format } from 'date-fns';

export const InvoiceNumberField = ({ record = {} }: any) => (
  <span>{`IFC${format(
    new Date(record.created_at),
    'yyyy'
  )}${record.id.toString().padStart(9, '0')}`}</span>
);
